/**
 * Active Indicator API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ActiveIndicatorRequestDto } from '../model/active-indicator-request';
// @ts-ignore
import { ActiveIndicatorsResponseDto } from '../model/active-indicators-response';
// @ts-ignore
import { CreateActiveIndicatorRequestDto } from '../model/create-active-indicator-request';
// @ts-ignore
import { ErrorResponseDto } from '../model/error-response';
// @ts-ignore
import { RetrieveActiveIndicatorsDto } from '../model/retrieve-active-indicators';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    ActiveIndicatorServiceInterface,
    CreateActiveIndicatorRequestParams,
    DisableActiveIndicatorRequestParams,
    EnableActiveIndicatorRequestParams,
    ListAllActiveIndicatorByWalletRequestParams
} from './active-indicator.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class ActiveIndicatorService extends BaseService implements ActiveIndicatorServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Create a new Active Indicator
     * @endpoint post /v1/active-indicator/wallet/{id}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public createActiveIndicator(requestParameters: CreateActiveIndicatorRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<ActiveIndicatorsResponseDto>;
    public createActiveIndicator(requestParameters: CreateActiveIndicatorRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<ActiveIndicatorsResponseDto>>;
    public createActiveIndicator(requestParameters: CreateActiveIndicatorRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<ActiveIndicatorsResponseDto>>;
    public createActiveIndicator(requestParameters: CreateActiveIndicatorRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling createActiveIndicator.');
        }
        const createActiveIndicatorRequestDto = requestParameters?.createActiveIndicatorRequestDto;
        if (createActiveIndicatorRequestDto === null || createActiveIndicatorRequestDto === undefined) {
            throw new Error('Required parameter createActiveIndicatorRequestDto was null or undefined when calling createActiveIndicator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (OidcBearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OidcBearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/active-indicator/wallet/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ActiveIndicatorsResponseDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: createActiveIndicatorRequestDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Disable an existing Active Indicator
     * @endpoint patch /v1/active-indicator/disable
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public disableActiveIndicator(requestParameters: DisableActiveIndicatorRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<ActiveIndicatorsResponseDto>;
    public disableActiveIndicator(requestParameters: DisableActiveIndicatorRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<ActiveIndicatorsResponseDto>>;
    public disableActiveIndicator(requestParameters: DisableActiveIndicatorRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<ActiveIndicatorsResponseDto>>;
    public disableActiveIndicator(requestParameters: DisableActiveIndicatorRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const activeIndicatorRequestDto = requestParameters?.activeIndicatorRequestDto;
        if (activeIndicatorRequestDto === null || activeIndicatorRequestDto === undefined) {
            throw new Error('Required parameter activeIndicatorRequestDto was null or undefined when calling disableActiveIndicator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (OidcBearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OidcBearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/active-indicator/disable`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ActiveIndicatorsResponseDto>('patch', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: activeIndicatorRequestDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Enable an existing Active Indicator
     * @endpoint patch /v1/active-indicator/enable
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public enableActiveIndicator(requestParameters: EnableActiveIndicatorRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<ActiveIndicatorsResponseDto>;
    public enableActiveIndicator(requestParameters: EnableActiveIndicatorRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<ActiveIndicatorsResponseDto>>;
    public enableActiveIndicator(requestParameters: EnableActiveIndicatorRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<ActiveIndicatorsResponseDto>>;
    public enableActiveIndicator(requestParameters: EnableActiveIndicatorRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const activeIndicatorRequestDto = requestParameters?.activeIndicatorRequestDto;
        if (activeIndicatorRequestDto === null || activeIndicatorRequestDto === undefined) {
            throw new Error('Required parameter activeIndicatorRequestDto was null or undefined when calling enableActiveIndicator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (OidcBearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OidcBearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/active-indicator/enable`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ActiveIndicatorsResponseDto>('patch', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: activeIndicatorRequestDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List all active indicator by walletId
     * @endpoint get /v1/active-indicator/wallet/{id}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listAllActiveIndicatorByWallet(requestParameters: ListAllActiveIndicatorByWalletRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<RetrieveActiveIndicatorsDto>;
    public listAllActiveIndicatorByWallet(requestParameters: ListAllActiveIndicatorByWalletRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<RetrieveActiveIndicatorsDto>>;
    public listAllActiveIndicatorByWallet(requestParameters: ListAllActiveIndicatorByWalletRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<RetrieveActiveIndicatorsDto>>;
    public listAllActiveIndicatorByWallet(requestParameters: ListAllActiveIndicatorByWalletRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling listAllActiveIndicatorByWallet.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (OidcBearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OidcBearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/active-indicator/wallet/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<RetrieveActiveIndicatorsDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
